// extracted by mini-css-extract-plugin
module.exports = {"vx8v5r7":"vx8v5r7","pulse-animation-vx8v5r7":"pulse-animation-vx8v5r7"};